<template lang="html">
  <div class="container" :class="$style.container">
    <slot />
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" module>
.container {
  padding: 28px 8px;
}
</style>
